<template>
    <v-form
        ref='form'
        v-model='valid'
        lazy-validation
        @submit.prevent='Login(model.user)'
    >
        <v-container>
            <InitialLoading :init-loading='loading'/>
            <v-row no-gutters class='justify-sm-center'>
                <v-col cols='12' sm='6'>
                    <v-row>
                        <v-col
                            cols='12' class='text-right pb-0'
                            style='padding-top: 30px'
                        >
                            <div
                                style='display: flex;
                        flex-direction: row;
                        align-items: center;'
                            >
                                <v-divider
                                    style='margin-left: 10px'
                                />
                                <img
                                    style='width: 60px;'
                                    src='/assets/logo-full.svg'
                                />
                                <v-divider
                                    style='margin-right: 10px'
                                />
                            </div>
                        </v-col>
                        <v-col cols='12'>
                            <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>ورود</h3>
                            <v-text-field
                                v-model='model.user.phone'
                                :rules='rules.user.phone'
                                type='number'
                                required
                                persistent-placeholder
                                @keypress='filterNumbers'
                            >
                                <template #label>
                                    <span class='red--text'><strong>* </strong></span>شماره تلفن همراه
                                </template>
                            </v-text-field>
                            <!--					<v-text-field-->
                            <!--						v-model='model.user.username'-->
                            <!--						:rules='rules.user.username'-->
                            <!--						required-->
                            <!--					>
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>نام کاربری
                                </template>
                            </v-text-field>-->
                        </v-col>
                        <v-col cols='12'>
                            <v-text-field
                                v-model='model.user.password'
                                :rules='rules.user.password'
                                persistent-placeholder
                                required
                                :type='showPassword ? "text":"password"'
                                :append-icon='showPassword ?"mdi-eye-outline":"mdi-eye-off-outline"'
                                @click:append='changePasswordType'
                            >
                                <template #label>
                                    <span class='red--text'><strong>* </strong></span>رمز عبور
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols='12'>
                            <v-btn
                                block
                                name='login'
                                :disabled='!valid'
                                color='primary'
                                :loading='loading'
                                type='submit'
                                @click='validate'
                            > ورود به سیستم
                            </v-btn>
                        </v-col>
                        <v-col cols='12'>
                            <router-link
                                class='v-btn v-btn--block'
                                :to='{
							name:"Signup"
						}'
                            >
                                <v-btn
                                    block
                                    outlined
                                >
                                    عضویت
                                </v-btn>

                            </router-link>
                        </v-col>
                        <v-col cols='12'>
                            <v-btn
                                text
                                small
                                color='primary'
                                :to='{
							name:"ForgetPassword"
						}'
                            >
                                فراموشی رمزعبور
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            v-model='dialog'
            max-width='290'
        >
            <v-card>
                <v-card-title class='headline'>خطا</v-card-title>

                <v-card-text v-if='error.statusCode=== 400'>
                    <p>خطایی در روند ورود به سیستم رخ داد <br>
                        کد خطا {{ error.statusCode }}
                    </p>
                    <!--					<p>شماره تلفن شما در لیست سیاه مخابرات قرار دارد. <br>لطفا با شماره دیگری از اپراتور ایرانسل یا-->
                    <!--						همراه اول استفاده کنید</p>-->
                </v-card-text>
                <v-card-text v-if='error.statusCode=== 403'>
                    <v-alert color='red' type='error'>دسترسی شما مسدود شده است. جهت بررسی با پشتیبانی تماس بگیرید
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        name='accept'
                        outlined
                        color='darken-1'
                        text
                        @click='dialog = false'
                    >متوجه شدم
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model='notFoundDialog'
            max-width='290'
        >
            <v-card>
                <v-card-title class='headline'>ورود انجام نشد</v-card-title>

                <v-card-text>
                    <p>از صحت شماره تلفن همراه و رمز عبور مطمئن شوید.</p>
                    <v-btn
                        block
                        class='mb-3'
                        color='primary'
                        :to="{name:'Signup'}"
                    >
                        ثبت نام
                    </v-btn>
                    <v-btn
                        name='accept'
                        block

                        @click='notFoundDialog = false'
                    >متوجه شدم
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import { mapActions } from 'vuex';
    import filterNumbers from '@/plugins/filterNumbers';
    import InitialLoading from '@/components/initialLoading';


    export default {
        name: 'Auth',
        components: { InitialLoading },
        data: () => ({
            valid: true,
            dialog: false,
            loading: false,
            showPassword: false,
            notFoundDialog: false,
            agent_id: null,
            error: {
                statusCode: null
            },
            model: {
                user: {
                    phone: '',
                    // username: '',
                    password: ''
                }
            },
            rules: {
                user: {
                    phone: [
                        v => !!v || 'شماره تلفن اجباری میباشد',
                        v => /^09\d{2}\d{7}$/.test(v) ? true : 'شماره تلفن صحیح نمیباشد'
                    ],
                    // username: [
                    // 	v => !!v || 'نام کاربری اجباری است',
                    // 	v => v.length > 1 ? true : 'نام کاربری باید بیش از ۱ حرف باشد',
                    // 	v => /^[a-zA-Z0-9]+$/.test(v) ? true : 'نام کاربری نمیتواند شامل حروف فارسی یا کاراکترهای خاص باشد'
                    // ],
                    password: [
                        v => !!v || 'رمز عبور اجباری میباشد',
                        v => v.length > 7 ? true : 'رمز عبور باید بیشتر از ۸ حرف باشد'
                    ]
                }

            }
        }),
        methods: {
            filterNumbers(keyEvent) {
                filterNumbers(keyEvent);
            },

            changePasswordType() {
                this.showPassword = !this.showPassword;
            },
            validate() {
                this.$refs.form.validate();
            },
            async addCustomerToAgent(agent_id) {
                axios
                    .put(`/api/agents/${agent_id}/assign`, {})
                    .then(async ({ data }) => {
                        await this.$cookies.set('agent_of_user', JSON.stringify(data.agent._id));
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            async Login(data) {
                this.loading = true;
                await axios.post('/api/users/login', data)
                    .then(async (response) => {
                        this.setUser(response.data.user);
                        this.setToken(response.data.token);
                        this.showNavigation(true);
                        axios.defaults.headers.common['Authorization'] = this.$cookies.get('token');
                        this.loading = false;
                        if (this.agent_id !== null) {
                            await this.addCustomerToAgent(this.agent_id);
                        }
                        let temp_url = new URL(localStorage.getItem('temp_url'));
                        if (!temp_url || /login|signup|verify|forgetPassword|404/.test(temp_url.pathname)) {
                            this.$router.push({
                                name: 'Home'
                            });
                        } else {
                            localStorage.removeItem('temp_url')
                            window.location.replace(temp_url);
                        }
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error(err);
                        this.error.statusCode = err.response.status;
                        if (err.response.status === 404) {
                            this.notFoundDialog = true;
                        } else {
                            this.dialog = true;
                            this.error.statusCode = err.response.status;
                        }
                    });
            },
            ...mapActions([
                'setToken', 'setUser', 'showNavigation'
            ])
        },
        mounted() {
            this.agent_id = JSON.parse(this.$cookies.get('agent_of_user'));
            this.$vuetify.theme.dark = this.$cookies.get('theme') === 'true';
            this.showNavigation(false);
            if (this.$cookies.get('token')) this.$router.push('/');
        },
        created() {

        }

    };
</script>
